// /*Author: Bhavya*/
// import React from "react";
// import history from "helper/history";

// import Layout from "./layout";

// import { NavigationChevronRight } from "../../customComponents/materialUI/icons";

// import {
//     CustomPrimaryButton as SaveButton,
//     CustomListItem as ListItem,
//     CustomDivider as Divider
// } from "../../customComponents/components";

// import LoginStore from "../../stores/loginstore";
// import * as LoginAction from "../../actions/loginaction";

// import i18n from "../../i18nNext";

// export default class MultiProfilePage extends React.Component {
//     constructor() {
//         super();
//         let profiles = LoginStore._getField("profiles");
//         this.state = {
//             profiles: profiles || [],
//             toggleBit: "mobile"
//         };
//     }
//     _backTopage() {
//         history.goBack();
//     }

//     _handleSubmit(userId, status, el) {
//         LoginAction.setAnyKey("userId", userId);
//         LoginAction.setAnyKey("mobileExt", el.mobile_extension);
//         if (status == 0) {
//             history.push("/login/passwordpage");
//         } else {
//             history.push("/login/mobileverificationpage");
//         }
//     }
//     _showProfiles() {
//         return this.state.profiles.map((el, i) => {
//             return (
//                 <div key={i}>
//                     <ListItem
//                         key={el.user_id}
//                         style={{ fontSize: 12, fontFamily: "Roboto-Regular", color: "#4a4a4a" }}
//                         onClick={this._handleSubmit.bind(this, el.user_id, el.auth_status, el)}
//                         primaryText={el.org_name ? `${el.org_name} (${el.org})` : `${el.org}`}
//                         rightIcon={<NavigationChevronRight />}
//                         secondaryText={
//                             <div>
//                                 <div>{el.email_id}</div>
//                                 <div>{el.mobile_extension + el.mobile_number}</div>
//                             </div>
//                         }
//                         secondaryTextLines={2}
//                     />
//                     <Divider />
//                 </div>
//             );
//         });
//     }

//     _renderSecondaryText(emailId, mobileExtension, mobileNumber) {
//         let { toggleBit } = this.state,
//             item = "";

//         item = (
//             <div>
//                 <img
//                     src={
//                         toggleBit == "mobile"
//                             ? "/assets/images/email-icon.svg"
//                             : "/assets/images/call-icon.svg"
//                     }
//                     className="appImg"
//                     width="10.9px"
//                     height="7.8px"
//                 />
//                 <span style={{ marginLeft: "5px" }}>
//                     {toggleBit == "mobile" ? emailId : mobileNumber}
//                 </span>
//             </div>
//         );

//         return <div style={{ color: "#16325c", fontWeight: 300, fontSize: 12 }}>{item}</div>;
//     }

//     _renderInputField(type) {
//         const { profiles } = this.state;
//         let list = profiles.map((el, i) => {
//             let secondaryText = this._renderSecondaryText(
//                 el.email_id,
//                 el.mobile_extension,
//                 el.mobile_number
//             );
//             const primaryText = el.org_name ? `${el.org_name} (${el.org})` : `${el.org}`;
//             let height =
//                 primaryText.length >= 47 ? (primaryText.length < 90 ? "75px" : "90px") : "58px";
//             return (
//                 <div key={i} className="chooseProfilelistContainer" style={{ height }}>
//                     <ListItem
//                         key={el.user_id}
//                         style={{ fontSize: 12, fontFamily: "Roboto-Regular", color: "#4a4a4a" }}
//                         innerDivStyle={{ padding: "10px", color: "#16325c", fontWeight: "normal" }}
//                         onClick={this._handleSubmit.bind(this, el.user_id, el.auth_status, el)}
//                         primaryText={<div style={{ width: "90%" }}>{primaryText}</div>}
//                         rightIcon={
//                             <NavigationChevronRight
//                                 style={{ top: 6, margin: 9, fill: "#D3DBEA" }}
//                             />
//                         }
//                         secondaryText={secondaryText}
//                         secondaryTextLines={1}
//                     />
//                 </div>
//             );
//         });

//         return (
//             <div className="loginContainer">
//                 <div className="chooseProfilelistItemContainer">{list}</div>
//                 <SaveButton
//                     id="saveBtn"
//                     label={i18n.t("btn.back")}
//                     type="submit"
//                     className="nextButton"
//                     style={{ width: "100%", margin: "0", top: "12px" }}
//                     onClick={this._backTopage.bind(this)}
//                 />
//             </div>
//         );
//     }

//     _selectTab(type) {
//         this.setState({
//             toggleBit: type
//         });
//     }

//     render() {
//         const { toggleBit } = this.state;
//         let user = LoginStore._getField("user"),
//             fromEmail = false;

//         if (user.indexOf("@") > 0) {
//             fromEmail = true;
//         }

//         return (
//             <div>
//                 <Layout
//                     subHeader="profile"
//                     fromEmail={fromEmail}
//                     selectedTab={type => this._selectTab(type)}
//                 />
//                 {this._renderInputField(toggleBit)}
//             </div>
//         );
//     }
// }

//---------------- Start External Library Import --------------------//
import React from "react";
import MultiProfilePage from "@techsoftware/happay-widgets/MultiprofilePage";
import history from "helper/history";
//---------------- End External Library Import --------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Stores Dependency Import -------------------------------------//
import LoginStore from "../../stores/loginstore";
//------------------- End Stores Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
import Common from "../../constants/common";
//------------------- End Helpers Dependency Import -------------------------------------//
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";
import poweredByHappay from "../../../public/assets/images/poweredByHappayImg.svg";

export default class multiProfilePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userProfiles: LoginStore._getField("profiles") || [],
            activeTab: LoginStore._getField("activeTab"),
            code: LoginStore._getField("c_code"),
            user: LoginStore._getField("user")
        };
    }

    onSignIn = value => {
        LoginAction.setAnyKey("userId", value.user_id);
        LoginAction.setAnyKey("mobileExt", value.mobile_extension);
        LoginAction.setAnyKey("otp", "");
        if (value.auth_status == 0) {
            history.push("/login/passwordpage");
        } else {
            history.push("/login/mobileverificationpage");
        }
    };

    render() {
        const { userProfiles, activeTab, code, user } = this.state;
        const { ProductLogo, breakPoints, privacyPolicyUrl, termOfUseUrl } = this.props;

        return (
            <MultiProfilePage
                containerClassName={`signin-container ${Common._checkIfHdfcUrl() ? 'hdfcPortal': 'happayPortal'}`}
                logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                onClickBack={() => {
                    history.goBack();
                }}
                userProfiles={userProfiles}
                onSignIn={this.onSignIn}
                breakPoints={breakPoints}
                profileConfig={{
                    orgName: true,
                    org: true
                }}
                data={{
                    code: code,
                    value: user,
                    activeTab: activeTab
                }}
                privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
                termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
                multiProfileHeader={i18n.t("logIn.chooseAProfile")}
                backButtonText={i18n.t("btn.back")}
                footerText={
                    Common._checkIfHdfcUrl() && (
                        <div className="d-flex alignItemCenter">
                            {i18n.t("lbl.poweredBy")}
                            <img src={poweredByHappay} width="80" className="margin-lr-5" />
                        </div>
                    )
                }
            />
        );
    }
}
